module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(!_vm.existingUserMode) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    staticClass: "col-md-6",
    attrs: {
      "name": "firstName",
      "label": "First Name",
      "validation": _vm.$v.user.firstname
    },
    model: {
      value: (_vm.user.firstname),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstname", $$v)
      },
      expression: "user.firstname"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-md-6",
    attrs: {
      "name": "lastName",
      "label": "Last Name",
      "validation": _vm.$v.user.lastname
    },
    model: {
      value: (_vm.user.lastname),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastname", $$v)
      },
      expression: "user.lastname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "emailAddress",
      "label": "Email Address",
      "validation": _vm.$v.user.emailAddress,
      "disabled": !!_vm.invitedEmail
    },
    model: {
      value: (_vm.user.emailAddress),
      callback: function($$v) {
        _vm.$set(_vm.user, "emailAddress", $$v)
      },
      expression: "user.emailAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "cellularAddress",
      "label": "Cellular Number",
      "validation": _vm.$v.user.cellularNumber
    },
    model: {
      value: (_vm.user.cellularNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "cellularNumber", $$v)
      },
      expression: "user.cellularNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_c('h4', {
    staticClass: "padding-bottom-10"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usernameType),
      expression: "usernameType"
    }],
    attrs: {
      "type": "radio",
      "id": "usernameTypeEmail",
      "name": "usernameType",
      "value": "EMAIL"
    },
    domProps: {
      "checked": _vm._q(_vm.usernameType, "EMAIL")
    },
    on: {
      "change": function($event) {
        _vm.usernameType = "EMAIL"
      }
    }
  }), _vm._v("\n            Use Email Address"), (_vm.usernameType === 'EMAIL') ? _c('span', [_vm._v(": " + _vm._s(_vm.user.emailAddress))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usernameType),
      expression: "usernameType"
    }],
    attrs: {
      "type": "radio",
      "id": "usernameTypeCellular",
      "name": "usernameType",
      "value": "CELLULAR"
    },
    domProps: {
      "checked": _vm._q(_vm.usernameType, "CELLULAR")
    },
    on: {
      "change": function($event) {
        _vm.usernameType = "CELLULAR"
      }
    }
  }), _vm._v("\n            Use Cellular Number"), (_vm.usernameType === 'CELLULAR') ? _c('span', [_vm._v(": " + _vm._s(_vm.user.cellularNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usernameType),
      expression: "usernameType"
    }],
    attrs: {
      "type": "radio",
      "id": "usernameTypeCustom",
      "name": "usernameType",
      "value": "CUSTOM"
    },
    domProps: {
      "checked": _vm._q(_vm.usernameType, "CUSTOM")
    },
    on: {
      "click": _vm.clearUsername,
      "change": function($event) {
        _vm.usernameType = "CUSTOM"
      }
    }
  }), _vm._v("\n            Create your own\n          ")])]), _vm._v(" "), (_vm.usernameType === 'CUSTOM') ? _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "username",
      "label": "Username",
      "validation": _vm.$v.user.username
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "password",
      "label": "Password",
      "validation": _vm.$v.user.password
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "validation": _vm.$v.confirmPassword
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-switch', {
    attrs: {
      "name": "identityType",
      "options": _vm.identityTypes
    },
    model: {
      value: (_vm.user.identityType),
      callback: function($$v) {
        _vm.$set(_vm.user, "identityType", $$v)
      },
      expression: "user.identityType"
    }
  })], 1)]), _vm._v(" "), (_vm.user.identityType === 'IDDOC') ? _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "identityNumber",
      "label": "Identity Number",
      "validation": _vm.$v.user.identityNumber
    },
    model: {
      value: (_vm.user.identityNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "identityNumber", $$v)
      },
      expression: "user.identityNumber"
    }
  })], 1)]) : (_vm.user.identityType === 'PASSPORT') ? _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "passportNumber",
      "label": "Passport Number",
      "validation": _vm.$v.user.passportNumber
    },
    model: {
      value: (_vm.user.passportNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "passportNumber", $$v)
      },
      expression: "user.passportNumber"
    }
  }), _vm._v(" "), _c('input-select', {
    attrs: {
      "name": "passportCountry",
      "label": "Passport Country",
      "options": _vm.countries,
      "validation": _vm.$v.user.passportCountry,
      "loading": _vm.loadingCountries
    },
    model: {
      value: (_vm.user.passportCountry),
      callback: function($$v) {
        _vm.$set(_vm.user, "passportCountry", $$v)
      },
      expression: "user.passportCountry"
    }
  })], 1)]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user.type === 'HCP') ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "discipline",
      "label": "Select Discipline",
      "options": _vm.disciplines,
      "validation": _vm.$v.user.hcp.discipline,
      "loading": _vm.loadingDisciplines
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadSpecialities($event)
      }
    },
    model: {
      value: (_vm.user.hcp.discipline),
      callback: function($$v) {
        _vm.$set(_vm.user.hcp, "discipline", $$v)
      },
      expression: "user.hcp.discipline"
    }
  })], 1), _vm._v(" "), (_vm.user.hcp.discipline) ? _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "speciality",
      "label": "Select Speciality",
      "options": _vm.specialities,
      "validation": _vm.$v.user.hcp.speciality,
      "loading": _vm.loadingSpecialities
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadRoles($event)
      }
    },
    model: {
      value: (_vm.user.hcp.speciality),
      callback: function($$v) {
        _vm.$set(_vm.user.hcp, "speciality", $$v)
      },
      expression: "user.hcp.speciality"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.hcp.speciality) ? _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "role",
      "label": "Select Role",
      "options": _vm.roles,
      "validation": _vm.$v.user.hcp.role,
      "loading": _vm.loadingRoles
    },
    model: {
      value: (_vm.user.hcp.role),
      callback: function($$v) {
        _vm.$set(_vm.user.hcp, "role", $$v)
      },
      expression: "user.hcp.role"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "hpcsa",
      "label": "HPCSA Number",
      "validation": _vm.$v.user.hcp.hpcsaNumber
    },
    model: {
      value: (_vm.user.hcp.hpcsaNumber),
      callback: function($$v) {
        _vm.$set(_vm.user.hcp, "hpcsaNumber", $$v)
      },
      expression: "user.hcp.hpcsaNumber"
    }
  })], 1), _vm._v(" "), (!_vm.user.inviteCode) ? _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "practiceNumber",
      "label": "Practice Number",
      "validation": _vm.$v.user.practiceNumber
    },
    model: {
      value: (_vm.user.practiceNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "practiceNumber", $$v)
      },
      expression: "user.practiceNumber"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.inviteCode) ? _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "practicePhone",
      "label": "Practice Phone Number",
      "validation": _vm.$v.user.phone.number
    },
    model: {
      value: (_vm.user.phone.number),
      callback: function($$v) {
        _vm.$set(_vm.user.phone, "number", $$v)
      },
      expression: "user.phone.number"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group col-sm-offset-3"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "terms",
      "required": ""
    }
  }), _vm._v(" I have read and accept the\n          "), _c('a', {
    staticClass: "highlight",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal($event)
      }
    }
  }, [_vm._v("Terms and Conditions")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "signUpSubmit",
      "loading": _vm.loading
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "open": _vm.conflictModalOpen,
      "size": "m"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeConflictModal
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Account Already Exists")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("An account with this email address or cellular number already exists. Please enter your existing LogBox credentials to link your practice.")]), _vm._v(" "), (_vm.conflictModalError) ? _c('div', {
    staticClass: "alert alert-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.conflictModalError)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.conflictFormKey
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "conflictUsername",
      "label": "Username"
    },
    model: {
      value: (_vm.conflictUsername),
      callback: function($$v) {
        _vm.conflictUsername = $$v
      },
      expression: "conflictUsername"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "conflictPassword",
      "label": "Password"
    },
    model: {
      value: (_vm.conflictPassword),
      callback: function($$v) {
        _vm.conflictPassword = $$v
      },
      expression: "conflictPassword"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeConflictModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.conflictLoading
    },
    on: {
      "click": _vm.saveWithCredentials
    }
  }, [(_vm.conflictLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _vm._e(), _vm._v("\n        Link Account\n      ")])])]), _vm._v(" "), _c('ud-terms-modal', {
    attrs: {
      "open": _vm.modalOpen,
      "id": "openTermsModal"
    },
    on: {
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eadf746"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/forms/PracticeForm.vue
// module id = 663
// module chunks = 5